import { IDocumentImageSource } from "../IDocumentImageSource";
import { IItem, instanceOfIItem } from "./IItem";
import { ImageKinds } from "../ImageKinds";

export interface IImageDrawable extends IItem {
  originalImageSource: IDocumentImageSource;
  imageSource: IDocumentImageSource;
  drawLayerImageSource: IDocumentImageSource;
  drawObjectData: string;
  imageKind: ImageKinds;
  claioImageId: string;
  imageDepartmentId: string;
  rotationAngle: number;
  externalImageId: string;
  clearImageInformation(): void;
  replaceImageSource(source: IDocumentImageSource): void;
}

export function instanceOfIImageDrawable(instance: any): instance is IImageDrawable {
  return instance
    && (instance.imageSource !== undefined)
    && (instance.imageKind !== undefined)
    && (instance.drawLayerImageSource !== undefined)
    && (instance.drawObjectData !== undefined)
    && (instance.clearImageInformation !== undefined)
    && instanceOfIItem(instance);
}
